// The latest product update. Users who joined before `time` see it once when
// they open Vello (tracked in user.seen[id]); publish a new one with a new id.
export const UPDATE = {
  id: 'update-2026-09-models',
  time: Date.parse('2026-09-30T00:00:00Z'),
  title: 'All-new models in Vello',
  description:
    'We refreshed the whole lineup to the newest models from Anthropic, OpenAI, Google and xAI.',
  note: 'Retired models are gone from the list. Your existing chats and characters move to the closest new model automatically.',
}
